import type { LoaderFunctionArgs } from "react-router";
import { redirect } from "react-router";
import { login, SHOPIFY_API_KEY } from "../../shopify.server";
import styles from "./styles.module.css";

export const loader = async ({ request }: LoaderFunctionArgs) => {
  const url = new URL(request.url);

  if (url.searchParams.get("shop")) {
    throw redirect(`/app?${url.searchParams.toString()}`);
  }

  return { showForm: Boolean(login) };
};

export default function App() {
  return <div className={styles.index}></div>;
}
